<template>
  <b-card>
    <div
      v-if="isLoading"
      variant="primary"
      disabled
      class="mr-1 text-center"
    >
      <b-spinner
        small
        type="grow"
      />
      Loading...
    </div>
    <validation-observer
      v-if="!isLoading"
      ref="infoRules"
      v-slot="{ invalid }"
      tag="form"
    >
      <b-row>
        <b-col md="6">
          <!-- Name -->
          <validation-provider
            #default="validationContext"
            name="From Date"
            rules="required"
          >
            <b-form-group
              label="From Date"
              label-for="From Date"
            >
              <b-form-input
                id="from-date"
                v-model="scheduleForm.from"
                type="date"
                :state="getValidationState(validationContext)"
                trim
                placeholder="From Date"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <!-- Name -->
          <validation-provider
            #default="validationContext"
            name="To Date"
            rules="required"
          >
            <b-form-group
              label="To Date"
              label-for="To Date"
            >
              <b-form-input
                id="to-date"
                v-model="scheduleForm.to"
                type="date"
                :state="getValidationState(validationContext)"
                trim
                placeholder="To Date"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <!-- Name -->
          <validation-provider
            #default="validationContext"
            name="type"
            rules="required"
          >
            <b-form-group
              label="Type"
              label-for="Type"
            >
              <b-form-select
                id="type"
                v-model="scheduleForm.type"
                :options="optionsType"
                :state="getValidationState(validationContext)"
                placeholder="type"
                @change="onTypeChange($event)"
              />
              <b-form-input
                v-if="haveOtherValues"
                v-model="scheduleForm.other"
                :state="getValidationState(validationContext)"
                placeholder="Enter Custom Type"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col md="6">
          <validation-provider
            #default="validationContext"
            rules="required"
            name="user"
          >

            <b-form-group
              label="User "
              label-for="User"
            >
              <v-select
                id="user"
                v-model="userId"
                :options="optionsUser"
                placeholder="user"
                :state="getValidationState(validationContext)"
                disabled
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>

          </validation-provider>
        </b-col>

        <b-col md="6">
          <!-- Name -->
          <validation-provider
            #default="validationContext"
            name="description"
            rules="required"
          >
            <b-form-group
              label="Description"
              label-for="Description"
            >
              <b-form-textarea
                id="description"
                v-model="scheduleForm.description"
                :state="getValidationState(validationContext)"
                trim
                placeholder="description"
                disabled
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <!-- Server Errors -->
        <b-col
          v-if="Object.values(errors).length > 0"
          cols="12"
        >
          <p
            v-for="(error, key, index) in errors"
            :key="index"
            class="text-danger small"
          >
            {{ error.toString() }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="mt-50"
        >

          <b-button
            v-if="!loader && $route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addSchedule()"
          >
            Save Changes
          </b-button>
          <b-button
            v-if="!loader && !$route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addSchedule()"
          >
            Add
          </b-button>
          <b-button
            v-if="loader"
            variant="primary"
            disabled
            class="mr-1"
          >
            <b-spinner
              small
              type="grow"
            />
            Loading...
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import axios from 'axios'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// eslint-disable-next-line no-unused-vars
import _ from 'lodash'
import VSelect from 'vue-select'
import decryptData from '@/store/auth/decryptData'

export default {
  components: {
    VSelect,
  },
  data() {
    return {
      id: this.$store.state.generalIds.id,
      required,
      allSelected: [],
      users: [],
      loader: false,
      validationErrors: {},
      errors: {},
      optionsUser: [],
      optionsType: [],
      userId: '',
      haveOtherValues: false,
      isLoading: false,
    }
  },
  setup() {
    const { getValidationState } = formValidation()
    // eslint-disable-next-line camelcase

    const scheduleForm = ref({})
    return {
      getValidationState,
      scheduleForm,
    }
  },
  mounted() {
    this.getUser()
    this.showSchedule()
  },
  methods: {
    onTypeChange(event) {
      if (event === 'other') {
        this.haveOtherValues = true
      } else {
        this.haveOtherValues = false
      }
    },
    showSchedule() {
      this.isLoading = true
      axios.get(`employee-schedule/${this.$route.params.id}`).then(res => {
        const getData = decryptData(res.data.payload).data.Schedule
        this.scheduleForm.from = getData.from
        this.scheduleForm.to = getData.to
        this.scheduleForm.description = getData.description
        const match = getData.type.match(/^([^(]+)\s*\(([^)]+)\)/)
        if (match) {
          this.haveOtherValues = true
          this.scheduleForm.type = match[1].trim()
          this.scheduleForm.other = match[2].trim()
        } else {
          this.scheduleForm.type = getData.type
        }

        this.userId = {
          value: getData.user.id,
          label: getData.user.name,
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    getUser() {
      this.isLoading = true
      Promise.all([axios.get('register/all'), axios.get('leave-types')]).then(res => {
        this.optionsUser = decryptData(res[0].data.payload).data.users.map(item => ({
          value: item.id,
          label: item.name,
        }))
        this.optionsType = decryptData(res[1].data.payload).data.leave_types.map(item => ({
          value: item,
          text: item,
        }))
      }).finally(() => {
        this.isLoading = false
      })
    },

    addSchedule() {
      if (this.$route.params.id) {
        this.loader = true
        const formData = new FormData()
        formData.append('_method', 'PUT')
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (const key in this.scheduleForm) {
          formData.append(key, this.scheduleForm[key])
        }

        axios.post(`employee-schedule/${this.$route.params.id}`, formData).then(res => {
          if (res.status === 200) {
            this.$router.push({ name: 'schedule' })
            this.$toasted.show('Updated Successfully', {
              position: 'top-center',
              duration: 3000,
            })
          }
        }).finally(() => {
          this.loader = false
        })
      } else {
        this.loader = true
        const formData = new FormData()
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for (const key in this.scheduleForm) {
          formData.append(key, this.scheduleForm[key])
        }

        axios.post('employee-schedule', formData).then(res => {
          if (res.status === 200 || res.status === 201) {
            this.$router.push({ name: 'schedule' })
            this.$toasted.show('Created Successfully', {
              position: 'top-center',
              duration: 3000,
            })
          }
        }).catch(error => {
          if (error.response.status) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `${error.response.data.message}`,
                icon: 'BellIcon',
                variant: 'error',
              },
            })
          }
        }).finally(() => {
          this.loader = false
        })
      }
    },
  },

}
</script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>
